// inbox-100 / roadmap G6 — клиент для /api/v1/campaigns.
// Backend: app/apps/api/campaigns.py (inbox-53).

import { ApiError } from './links';

export interface Campaign {
  id: number;
  name: string;
  description: string | null;
  status: 'active' | 'paused' | 'done';
  color: string;
  link_count: number;
  created_at: string;
  updated_at: string;
}

export interface CampaignCreate {
  name: string;
  description?: string | null;
  status?: 'active' | 'paused' | 'done';
  color?: string;
}

export interface CampaignUpdate {
  name?: string;
  description?: string | null;
  status?: 'active' | 'paused' | 'done';
  color?: string;
}

export interface CampaignStats {
  campaign_id: number;
  clicks_total: number;
  clicks_unique: number;
  cr: number; // conversion rate в долях (0..1)
  links: number;
  range_start: string;
  range_end: string;
}

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch('/api/v1' + path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    ...init,
  });
  if (!res.ok) {
    let detail = '';
    const cloned = res.clone();
    try {
      const j = await res.json();
      detail = j.detail || j.error || JSON.stringify(j);
    } catch {
      detail = await cloned.text();
    }
    throw new ApiError(res.status, detail);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const CampaignsApi = {
  list(): Promise<Campaign[]> {
    return req<Campaign[]>('/campaigns');
  },
  create(body: CampaignCreate): Promise<Campaign> {
    return req<Campaign>('/campaigns', { method: 'POST', body: JSON.stringify(body) });
  },
  get(id: number): Promise<Campaign> {
    return req<Campaign>(`/campaigns/${id}`);
  },
  patch(id: number, body: CampaignUpdate): Promise<Campaign> {
    return req<Campaign>(`/campaigns/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
  },
  delete(id: number): Promise<void> {
    return req<void>(`/campaigns/${id}`, { method: 'DELETE' });
  },
  stats(id: number): Promise<CampaignStats> {
    return req<CampaignStats>(`/campaigns/${id}/stats`);
  },
};

// Палитра цветов для UI выбора (соответствует hex-pattern бэка)
export const CAMPAIGN_COLORS = [
  '#4f8cff', '#b366ff', '#4dd693', '#ff8b4d',
  '#ff5d8f', '#f1c14d', '#5cd7e1', '#9aa5b1',
];
